module.exports = __webpack_public_path__ + "img/google_.9bcd611e.png";